import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../../../../shared/service/token.service';

@Component({
  selector: 'app-login-success',
  templateUrl: './login-success.component.html',
  styleUrl: './login-success.component.scss',
})
export class LoginSuccessComponent implements OnInit {
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public tokenService: TokenService
  ) {}
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.tokenService.saveToken(params['token']);
      this.tokenService.saveRefreshToken(params['refresh-token']);
      this.router.navigateByUrl('/dashboard');
    });
  }
}
